import styled from 'styled-components';
import {theme} from '@styles/theme';

export const PageTitleDropdownBtnWrapper = styled.div`
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.basic05};
  cursor: pointer;
`;

export const PageTitleDropdownWrapper = styled.div`
  position: absolute;
  top: 32px;
  width: 320px;
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.basic08};
  padding: 8px;
  border: 1px solid ${theme.colors.basic05};
  border-radius: ${theme.roundedMedium};
  z-index: 9;
`;

export const PageTitleDropdownRow = styled.div`
  padding: 8px;
  cursor: pointer;
  &:hover {
    background-color: ${theme.colors.basic07};
  }
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
